export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/channel-travel.0ea6d291-90bd68.svg";